<div class="timeline-layers">
  <app-timeline-layer
    *ngFor="let layerId of layerIds"
    [layerId]="layerId"
    [canvasPositions]="canvasPositions"
  ></app-timeline-layer>
</div>



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-layers/timeline-layers.component.html